import { useState } from 'react';

export type OptionValue = {
  label: string;
  value: number | string;
} | {
  label: string;
  value: number | string;
}[]
| number[] | string[]

export type FieldValue = string | number | Array<string | number> | OptionValue | undefined | boolean

export type FilterState = {
  [pageSlug: string]: {
    [field: string]: FieldValue | {[key: string]: FieldValue} //name_contain: 'abc' || metricId_in: [1, 5]
  }
}


export default () => {
  const [filterState, setState] = useState<FilterState>();

  const setFilterState = (pageSlug: string, value: {[field: string]: FieldValue}): void => {
    setState({
      ...filterState,
      [pageSlug] : value
    })
  }

  const setFilterStateByKey = (pageSlug: string, key: string, value: FieldValue, prefix: string = ''): void => {
    if((Array.isArray(value) && value.length) || (!Array.isArray(value) && (value !== null || value !== undefined))) {
      const prefixValue = Object.assign(filterState?.[pageSlug]?.[prefix] || {}, {
        [key]: value
      })

      const keyState = prefix ? prefix : key
      const valueState = prefix ? prefixValue : value
      
      setState({
        ...filterState,
        [pageSlug] : {
          ...filterState?.[pageSlug],
          [keyState]: valueState
        }
      })
    } else {
      if(!prefix) {
        let tmpState = filterState?.[pageSlug]
        delete tmpState?.[key]
        setState({
          ...filterState,
          [pageSlug] : {
            ...tmpState
          }
        })
      } else {
        let tmpState = filterState?.[pageSlug]?.[prefix] as FilterState
        if(tmpState) {
          delete tmpState?.[key]
        }
        setState({
          ...filterState,
          [pageSlug] : {
            ...filterState?.[pageSlug],
            [prefix]: tmpState
          }
        } as FilterState)
      }
    }
  }
  return { filterState, setFilterState, setFilterStateByKey };
};